import ReactGA from 'react-ga';

export const sendEvent = ({ name, category }) => ReactGA.event({ action: name, category });
